import { skills } from "../data/skills";

const Skills = () => (
  <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
    {skills.map((skill, i) => (
      <span
        key={i}
        className="px-4 py-2 rounded-full text-sm bg-white/5 border border-white/10 hover:border-teal-400/50 text-slate-300 hover:text-white shadow-[0_0_8px_rgba(0,224,183,0.1)] transition-all"
      >
        {skill}
      </span>
    ))}
  </div>
);

export default Skills;
